<template>
    <form class="chat-head__search" @submit.prevent="submit" @keyup.enter.native="enter">
        <div class="search-controls">
            <img
                :src="env.public_base + '/assets/images/cross-icon.svg'"
                @click="reset"
                alt
                v-if="search_value !== ''"
                class="search-buttons"
            />
        </div>
        <label class="search__label" for></label>
        <input class="search__input" v-model="search_value" type="text" :placeholder="placeholder"/>
        <template v-if="!isPayer">
            <button class="search__button">
                <img :src="env.public_base + '/assets/images/search-icon.svg'" alt/>
            </button>
        </template>
        <template v-else>
        <button class="search__button" @click="searchPayer">
            <img :src="env.public_base + '/assets/images/search-icon.svg'" alt/>
        </button></template>
    </form>
</template>

<script>
    import env from "../../env";
    import {mapGetters} from "vuex";

    export default {
        props: {
            lessonItemId: String,
            placeholder: {
                type: String,
            },
            searchMethod: {
                type: String,
                default: "getCourseTheme"
            },
            checkwork: {
                type: Boolean,
                default: false
            },
            student_id: {
                type: Number,
                default: 0
            },
            mechanicalEvent: {
                type: Boolean,
                default: false,
            }
        },
        data: () => ({
            env,
            value: "",
            counter: 0,
            show: false,
            changed: false,
            counterStart: false
        }),
        computed: {
            ...mapGetters(["" +
                "current_course",
                "current_course",
            ]),
            search_value: {
                get: function () {
                    return this.$store.getters["search_value"];
                },
                set: function (value) {
                    this.$store.commit("SET_SEARCH_VALUE", value);
                }
            },
            isPayer() {
                return this.$router.options.base.indexOf('payer') > -1 ;
            },
        },
        methods: {
            search() {
                console.log('0', 'consoling')

                if(this.mechanicalEvent) {
                    this.$emit('search', this.$store.getters["search_value"]);
                    return;
                }
                console.log('1', 'consoling')
                let params = {
                    q: this.search_value,
                    course_id: this.current_course.id
                };
                if (this.$store.getters["search_value"] === "") {
                    this.$store.commit("SET_SEARCH_FOUND", false);
                } else {
                    this.$store.commit("SET_SEARCH_FOUND", true);
                }

                if(this.checkwork) params.checkwork = true;
                if(this.lessonItemId) params.lesson_item_id = this.lessonItemId;
                if(this.student_id) params.student_id = this.student_id;
                this.$store.dispatch(this.searchMethod, params);
            },
            searchPayer() {
                if(this.mechanicalEvent) {
                    this.$emit('search', this.$store.getters["search_value"]);
                    return;
                }
                let searchParams = (new URL(document.location)).searchParams;
                if (this.$route.name === 'history_payment') {
                    this.$store.dispatch('GET_PAYMENTS_PAYER', {
                        id: this.$route.params.child_id,
                        page: 1,
                        q: this.search_value
                    });
                } else if (this.$route.name === 'documents') {
                    this.$store.dispatch('GET_DOCUMENTS_PAYER', {
                        id: this.$route.params.child_id,
                        page: 1,
                        page_size: searchParams.has('rows') ? searchParams.get('rows') : 5,
                        q: this.search_value
                    });
                }
                this.$store.commit('SET_REFRESH_PAGES', searchParams);
            },
            reset() {
                if(this.mechanicalEvent) {
                    this.$emit('reset');
                    return;
                }
                this.search_value = "";

                if (!(this.$route.name === 'history_payment' || this.$route.name === 'documents')) {
                    let params = {
                    q: this.$store.getters["search_value"],
                    course_id: this.current_course.id
                };

                    if(this.checkwork) params.checkwork = true;
                    if(this.lessonItemId) params.lesson_item_id = this.lessonItemId;
                    if(this.student_id) params.student_id = this.student_id;
                    this.$store.dispatch(this.searchMethod, params);
                }

                if(this.$route.name === 'history_payment') {
                    this.$nextTick(() => {
                        this.$emit('reset');
                    });
                }
            },
            submit() {
                if(this.mechanicalEvent) {
                    this.$emit('search', this.$store.getters["search_value"]);
                    return;
                }
                return this.isPayer ? this.searchPayer() : this.search()
            },
            enter() {
                if(this.mechanicalEvent) {
                    this.$emit('search', this.$store.getters["search_value"]);
                    return;
                }
                return this.isPayer ? this.searchPayer() : this.search()
            }
        },
        created() {
            let searchVal,
                searchParams = (new URL(document.location)).searchParams;
            if (searchParams.has('q')) {
                searchVal = searchParams.get('q');

                if (this.$route.name === 'history_payment' || this.$route.name === 'documents') {
                    this.$store.commit("SET_SEARCH_VALUE", searchVal);
                }
            }
        }
    };
</script>

<style lang="scss">
    .search-controls {
        display: flex;
        align-items: center;

        * {
            margin: 0 10px;
            white-space: nowrap;
        }
    }

    .search-buttons {
        cursor: pointer;
        background-color: transparent;
        padding: 0;

        img {
            margin: 0;
        }

        &:disabled:hover {
            opacity: 1;
        }
    }

    .search-buttons--up {
        transform: rotate(180deg);
    }
</style>
